let outlets = [];

if (window.mapData && Array.isArray(window.mapData.outlets)) {
  outlets = mapData?.outlets;
  window.onload = initMap;
}

function initMap() {
  const map = new google.maps.Map(
    document.getElementById("portfolio-map__map"),
    {
      center: { lat: -31.3465172, lng: 145.0392164 },
      zoom: 4.2,
      disableDefaultUI: true,
      mapId: "b35d482dc44d47aef871ffcd",
    }
  );

  document
    .querySelector(".portfolio-map__button--zoom-in")
    ?.addEventListener("click", () => map.setZoom(map.getZoom() + 1));

  document
    .querySelector(".portfolio-map__button--zoom-out")
    ?.addEventListener("click", () => map.setZoom(map.getZoom() - 1));

  const svgMarker = `${mapData.themeUri}/assets/images/marker.svg`;
  const markers = [];

  //Create ONE global InfoWindow
  const infoWindow = new google.maps.InfoWindow();

  outlets.forEach(
    ({
      lat,
      lng,
      name,
      logo,
      logo_two,
      logo_two_alt,
      logo_alt,
      logo_three,
      logo_three_alt,
      description,
      location
    }) => {

      
      // Marker container
      const markerDiv = document.createElement("div");
      markerDiv.style.width = "43.5px";
      markerDiv.style.height = "54px";

      const img = document.createElement("img");
      img.src = svgMarker;
      img.style.width = "100%";
      img.style.height = "100%";
      markerDiv.appendChild(img);

      // Advanced Marker
      const marker = new google.maps.marker.AdvancedMarkerElement({
        map,
        position: { lat: parseFloat(lat), lng: parseFloat(lng) },
        title: name,
        content: markerDiv,
      });

      markers.push(marker);

      // Click event
      marker.addListener("click", () => {

        infoWindow.setContent(`
          <div class="info-window">
            <div>
              <h3>${name} ${location}</h3>
              <p>${description}</p>
            </div>
            <div class="image-wrap">
              ${logo ? `<img src="${logo}" alt="${logo_alt || ""} Logo">` : ""}
              ${logo_two ? `<img src="${logo_two}" alt="${logo_two_alt || ""} Logo">` : ""}
              ${logo_three ? `<img src="${logo_three}" alt="${logo_three_alt || ""} Logo">` : ""}
            </div>
          </div>
        `);

        // Automatically closes previous popup
        infoWindow.open({
          anchor: marker,
          map,
        });

      });

    }
  );

  // Optional: close popup when clicking map background
  map.addListener("click", () => {
    infoWindow.close();
  });

  // Marker Clusterer
  new markerClusterer.MarkerClusterer({
    map,
    markers,
    algorithm: new markerClusterer.SuperClusterAlgorithm({
      radius: 120,
      maxZoom: 11,
    }),
    renderer: {
      render: ({ count, position }) => {
        return new google.maps.Marker({
          position,
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 25,
            fillColor: "#002C58",
            fillOpacity: 0.85,
            strokeColor: "#ffffff",
            strokeOpacity: 0.3,
            strokeWeight: 10,
          },
          label: {
            text: String(count),
            color: "#ffffff",
            fontSize: "16px",
            fontWeight: "600",
          },
        });
      },
    },
  });
}
